import React, { useRef } from 'react';
import { Container, Row, Col, Card, Form, Button, Breadcrumb } from 'react-bootstrap';
import Header from '../page-layout/header/Header';
import NavMenu from '../navigation/Navmenu';
import Footer from '../page-layout/footer/Footer';
import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Multiselect from 'multiselect-react-dropdown';
import moment from 'moment';
import { CreateOrganization, GetOrganizationById, UpdateOrganization, GetOrganization } from '../../utils/axios/CompanyAPI';
import { TimerAlert, ConfirmAlert } from '../../utils/swtAlert';
import { GetGeoLocation } from '../../utils/axios/GeoLocationAPI';
import { GrokLoading } from '../page-layout/loading/Loading';
import { GetLookUps } from '../../utils/axios/LookUpAPI';
import { CreateUser } from '../../utils/axios/UserApi';
import { Authentication } from '../../utils/axios/Auth';
import { Decrypt, Encrypt, GetSignedInUserInfo } from "../../utils/Helper";
import { InforAlert } from '../../utils/swtAlert';
import configData from '../../config.json';
import { ROLE, ORGANIZATION_TYPE, FetchLookups } from "../constants/constants";

import "./enrollAcademicInst.css";



function EnrollAcademicInst(props) {
    const [isOpen, setIsOpen] = useState(false);
    const [userInfo, setuserInfo] = useState();
    const navigate = useNavigate();
    const location = useLocation();
    const [validated, setValidated] = useState(false);
    const [isUpdate, setIsUpdate] = useState();
    const [loading, setLoading] = useState(true);

    const [logoURL, setLogoURL] = useState(null);
    const [progresspercent, setProgresspercent] = useState(0);

    //Form Control Variables Starts..
    const [collegeName, setCollegeName] = useState("");
    const [email, setEmail] = useState("");
    const [business, setBusiness] = useState("");
    const [collegeBrief, setCollegeBrief] = useState("");
    const [address, setAddress] = useState("");
    const [country, setCountry] = useState("");
    const [state, setState] = useState("");
    const [city, setCity] = useState("");
    const [district, setDistrict] = useState("");
    const [pincode, setPincode] = useState("");
    const [contactName, setContactName] = useState("");
    const [contactNumber, setContactNumber] = useState('');
    const [contactDesignation, setContactDesignation] = useState("");
    const [contactEmail, setContactEmail] = useState("");
    const [countryList, setCountryListData] = useState([]);
    const [stateList, setStateListData] = useState([]);
    const [districtList, setDistrictListData] = useState([]);
    const [cityListData, setCityListData] = useState([]);
    const [industryTypeList, setIndustryTypeList] = useState([]);
    const [businessTypeList, setBusinessTypeList] = useState([]);
    const [organizationTypeList, setOrganizationTypeList] = useState([]);
    const [branch, setBranch] = useState("");
    const [branchlist, setBranchlist] = useState([]);
    const [isEnabled, setIsEnabled] = useState(false);
    //Form Control Variables Ends..
    const [selectedBranches, setSelectedBranches] = useState([]);
    const [showRemoveButton, setShowRemoveButton] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [numberError, setNumberError] = useState("");
    const [numberSuccess, setNumberSuccess] = useState("");
    const [grovatorcollegetype,setgrovatorcollegetype] = useState([]);
    const [grovatortype,setGrovatortype] = useState("")

    const isValidContactNumber = (e) => /^[6-9][0-9]+$/.test(e);

    const setValuePhoneNumber = (evt) => {
        setContactNumber(evt);

        // if (isValidContactNumber(evt)) {
        //     setNumberSuccess(true);
        //     setNumberError("");
        // } else {
        //     setNumberError("Number should start with 6, 7, 8, or 9");
        //     setNumberSuccess(false);
        // }
    }

    function convertToBase64(e) {
        var file = e.target.files[0];
        if (file) {
            if (file.size <= 5 * 1024 * 1024) {
                var reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => {
                    setLogoURL(reader.result);
                    setErrorMessage('');
                    setShowRemoveButton(false);
                };
                reader.onprogress = (e) => {
                    setProgresspercent(((e.loaded / e.total) * 100).toFixed());
                };
                reader.onerror = error => {
                    console.log("Error:", error);
                };
            } else {
                setErrorMessage("File size exceeds 5MB");
                setShowRemoveButton(true);
            }
        }
    }

    const fileInputRef = useRef(null);

    function handleRemoveLogo() {
        setLogoURL(null);
        setErrorMessage('');
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
        setShowRemoveButton(false);
    }

    const BackBtn = () => {
        //Terminate session/logout method
        ConfirmAlert("All progress on this page will be lost! Do you want to move back?", 'Are you sure?', 'warning', 'Yes, move to home page!')
        .then((result) => {
            if (result.isConfirmed) {
                localStorage.removeItem('user');
                sessionStorage.removeItem("token");
                sessionStorage.removeItem("userDetails");
                sessionStorage.removeItem("orgDetail");
                const theme = localStorage.getItem('theme');
                localStorage.setItem('closeTabTheme', theme);
                localStorage.setItem('theme', 'light')
                navigate("/businesschallenges");
            }
        });
    }

    const handleLogin = async () => {
        let email = configData.ID_login;
        let password =  configData.Key_login;
        let authPayload = {
            Email: email,
            Password: password
        }
        setLoading(true);
        let authenticate = await Authentication(authPayload);
        setLoading(false);
        if (authenticate.success) {
            TimerAlert("You'll be redirected to change password", "Now create your password", 'success');
            sessionStorage.setItem('Email', Encrypt(authenticate.userIdAndEmail.Email));
            sessionStorage.setItem('UserId', Encrypt(authenticate.userIdAndEmail.Id));
            navigate('/changepassword');
        }
        else if (authenticate.response.data === "User Organization not found") {
            TimerAlert("Access Denied!", "User Organization not found", "error")
        }
        else if (authenticate.response.data === "Access Denied") {
            TimerAlert("Access Denied", "Please contact grok admin", "info");
        }
        else if (authenticate.response.data === "Invalid Credentials or User is Disabled") {
            TimerAlert("Invalid Credentials", "Please try again...", "error");
        }
        else if (authenticate.response.data === "All challenge registrations have expired. Please register new challenges to activate.") {
            InforAlert("All challenge registrations have expired. Please register new challenges to Activate.", "No Active Challenges!", "error", "Ok");
        }
        else if (authenticate.response.status === 200) {
            sessionStorage.setItem('token', Encrypt(authenticate.data.token));
            sessionStorage.setItem('userInfo', Encrypt(JSON.stringify(GetSignedInUserInfo())));
            const close = localStorage.getItem('close');
            localStorage.setItem('theme', close)

            localStorage.setItem('user', Encrypt(email));
            localStorage.setItem('pwd', Encrypt(password));
            await FetchLookups();
            return 'authenticated';
        }
        return 'Not authenticated';
    };


    const handleSubmit = (event) => {
        if (event && event.preventDefault) {
            event.preventDefault();
            const form = event.currentTarget;

            if (selectedBranches.length === 0) {
                setValidated(true);
                return;
            }

            if (form && form.checkValidity && form.checkValidity() === false) {
                event.stopPropagation();
                setValidated(true);
                return;
            }

            // if (!isValidContactNumber(contactNumber)) {
            //     setNumberError("Number should start with 6, 7, 8, or 9");
            //     return;
            // }

            if (errorMessage) {
                setErrorMessage("File size exceeds 5MB");
                return;
            }

            else {
                saveOrganization();
            }
        }
    }

    const saveOrganization = async () => {
        let OrganisationTypeID = ORGANIZATION_TYPE.COLLEGE; // OrganizationType - College
        let organizationPayload = {
            Business: null,
            OrganizationType: OrganisationTypeID, // OrganizationType - College
            IsGrovatorCollege: grovatortype,
            Name: collegeName,
            Email: email,
            IndustryType: null,
            Brief: collegeBrief,
            Address1: address,
            Country: country,
            City: city,
            District: district,
            Pincode: pincode,
            State: state,
            ContactName: contactName,
            ContactNumber: contactNumber,
            ContactDesignation: contactDesignation,
            ContactEmail: contactEmail,
            IsEnable: true,
            IsApproved: false,
            Logo: logoURL,
            Branch: selectedBranches.map(item => item.value)

        }
        organizationPayload.CreatedBy = userInfo._id;
        var response = await CreateOrganization(organizationPayload);
        if (response.message) {
            TimerAlert('Associate College Creation Failed', 'Oops Something Went Wrong', 'error');
        }
        else {
                //IF the repsonse is sucessful: Associate College Added Sucessful
                // Fetch the organisation details from the API: Get ALL Organisation
                setLoading(true);
                let organizationPayload = {
                    OrganizationType: OrganisationTypeID
                }
                var orgResponse = await GetOrganization(organizationPayload);
                // Keep a variable to store the organisation Name, find the Object ID with this name.
                let orgID = orgResponse.data.find(item => item.Name === collegeName)._id;
                //Using the above information create the new user for the organisation.
                let userPayload = {
                    OrganizationId: orgID,
                    RoleId: ROLE.COLLEGE,//Role - College
                    Name: contactName,
                    Email: contactEmail,
                    Password: 'password',
                    ContactNumber: contactNumber,
                    PhotoURL: logoURL,
                    CreatedBy: userInfo._id,
                    Enabled: false
                }
                //Call the API to create the user.
                var response = await CreateUser(userPayload);
                setLoading(false);
                if(response.message) {
                    TimerAlert('User Creation Failed', 'Email already used', 'error');
                }
                else {
                    InforAlert("Thank you, we have recorded your response.", `Your profile is under review. Once it is approved you can login with following credentials User ID: ${contactEmail} Password: password`, 'success', 'Move to home page!')
                    .then((result) => {
                        if (result.isConfirmed) {
                            localStorage.removeItem('user');
                            sessionStorage.removeItem("token");
                            sessionStorage.removeItem("userDetails");
                            sessionStorage.removeItem("orgDetail");
                            const theme = localStorage.getItem('theme');
                            localStorage.setItem('closeTabTheme', theme);
                            localStorage.setItem('theme', 'light')
                            // document.documentElement.setAttribute('data-theme', 'light');
                            navigate("/businesschallenges");
                        }
                    });
                }
        }
    }
    const bindFormPreloadData = async () => {
        setLoading(true);
        let res = await handleLogin();
        setuserInfo(JSON.parse(Decrypt(sessionStorage.getItem('userInfo'))));
        // const [userInfo, setuserInfo] = useState(JSON.parse(Decrypt(sessionStorage.getItem('userInfo'))));
        //Getting Country List from Geolocations
        var countrylist = await loadGeoLocationData(0, 1);
        setCountryListData(countrylist);
        // var statelist = await loadGeoLocationData(0, 1);
        // // if (statelist.success) {
        // setStateListData(statelist);
        // }
        // else {
        //Error Handle..
        // }
        let industryTypePayLoad = {
            Type: 3,
        }
        var industryTypeResponse = await GetLookUps(industryTypePayLoad);
        setIndustryTypeList(industryTypeResponse.data);

        let businessTypePayLoad = {
            Type: 4,
        }
        var businessTypeResponse = await GetLookUps(businessTypePayLoad);
        setBusinessTypeList(businessTypeResponse.data);

        let organizationTypePayLoad = {
            Type: 5,
        }
        var organizationTypeResponse = await GetLookUps(organizationTypePayLoad);
        setOrganizationTypeList(organizationTypeResponse.data);

        //Getting Branch List from Lookup
        let branchPayload = {
            Type: 7
        }
        var branchResponse = await GetLookUps(branchPayload);
        setBranchlist(branchResponse.data);
        setLoading(false);

        let grovatorcollegepayload ={
            Type:9
        }
        var grovatorcollegeResponse = await GetLookUps(grovatorcollegepayload);
        console.log(grovatorcollegeResponse);
        setgrovatorcollegetype(grovatorcollegeResponse.data);

    };
    const loadGeoLocationData = async (rootId, type) => {
        var result = await GetGeoLocation(rootId, type);
        return result;
    };

    const countryChanged = async (event) => {
        setCountry(event.target.value);
        if(event.target.value !== ''){
            const selectedItemId = event.target.value;
            const selectedItem = countryList.find((item) => item._id === selectedItemId)
            setLoading(true);
            var states = await loadGeoLocationData(selectedItem.Id, 2);
            setStateListData(states);
            setDistrictListData([]);
            setCityListData([]);
            setState("");
            setDistrict("");
            setCity("");
            setLoading(false);
        }
        else {
            setState('');
            setDistrict('');
            setCity('');
            setStateListData([]);
            setDistrictListData([]);
            setCityListData([]);
        }
        // if (states.success) {
        //     setStateListData(states.data);
        //     //Clear District dropdown
        //     // setDistrictListData(null);
        //     //Clear City dropdown
        //     // setCityListData(null);
        // }
        // else {
        //     //Error Handle..
        // }
    };

    const stateChanged = async event => {
        setState(event.target.value);
        if(event.target.value !== ''){
            // setValidated(false);
            const selectedItemId = event.target.value;
            const selectedItem = stateList.find((item) => item._id === selectedItemId)
            setLoading(true);
            var districts = await loadGeoLocationData(selectedItem.Id, 3);
            setDistrictListData(districts);
            setCityListData([]);
            setDistrict("");
            setCity("");
            setLoading(false);
        }
        else {
            setDistrict('');
            setDistrictListData([]);
            setCityListData([]);
            setCity("");
        }
        // if (districts.success) {
        //     setDistrictListData(districts.data)
        //     //Clear City dropdown
        //     // setCityListData(null);
        // }
        // else {
        //     //Error Handle..
        // }
    };

    const districtChanged = async (event) => {
        setDistrict(event.target.value);
        if(event.target.value !== ''){
            const selectedItemId = event.target.value;
            const selectedItem = districtList.find((item) => item._id === selectedItemId)
            setLoading(true);
            var cities = await loadGeoLocationData(selectedItem.Id, 4);
            setCityListData(cities);
            setCity("");
            setLoading(false);
        }
        else {
            setCityListData([]);
            setCity("");
        }
        // if (cities.success) {
        //     setCityListData(cities.data);
        // } else {
        //     //Error Handle..
        // }
    };

    const cityChanged = async (event) => {
        setCity(event.target.value);
    }
    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && event.target.tagName === 'INPUT') {
            event.preventDefault();
        }
    };
    const bindFormData = async () => {
        if (location.state.collegeid != null) {
            setLoading(true);
            var countrylist = await loadGeoLocationData(0, 1);
            var response = await GetOrganizationById(location.state.collegeid);

            const selectedCountryId = response.data[0].Country.Id;
            const selectedCountry = countrylist.find((item) => item._id === selectedCountryId);

            var states = await loadGeoLocationData(selectedCountry.Id, 2);
            setStateListData(states);

            const selectedStateId = response.data[0].State.Id;
            const selectedState = states.find((item) => item._id === selectedStateId);

            var districts = await loadGeoLocationData(selectedState.Id, 3);
            setDistrictListData(districts)

            const selectedDistrictId = response.data[0].District.Id;
            const selectedDistrict = districts.find((item) => item._id === selectedDistrictId)

            var cities = await loadGeoLocationData(selectedDistrict.Id, 4);
            setCityListData(cities);

            setGrovatortype(response.data[0]?.IsGrovatorCollege?.Id);
            setCollegeName(response.data[0].Name);
            setEmail(response.data[0].Email);
            setCollegeBrief(response.data[0].Brief);
            setAddress(response.data[0].Address1);
            setCountry(response.data[0].Country.Id);
            setState(response.data[0].State.Id);
            setDistrict(response.data[0].District.Id);
            setCity(response.data[0].City.Id);
            setPincode(response.data[0].Pincode);
            setContactName(response.data[0].ContactName);
            setContactEmail(response.data[0].ContactEmail);
            setContactNumber(response.data[0].ContactNumber);
            setContactDesignation(response.data[0].ContactDesignation);
            setIsEnabled(response.data[0].IsEnable);
            setLogoURL(response.data[0].Logo);
            setLoading(false);

            const updatedBranches = response.data[0].Branch?.map(item => {
                return {
                    label: item.Name,
                    value: item.Id
                };
            });
            setSelectedBranches(updatedBranches);
        }
    }
    const clearState = () => {
        setGrovatortype("");
        setCollegeName("");
        setEmail("");
        setCollegeBrief("");
        setAddress("");
        setCountry("");
        setState("");
        setDistrict("");
        setCity("");
        setPincode("");
        setContactName("");
        setContactEmail("");
        setContactNumber("");
        setContactDesignation("");
        setIsEnabled("");
        setSelectedBranches("");
        document.getElementById('logo').value = "";
        setLogoURL('');
    };
    const clear = () => {
        ConfirmAlert("Do you want to clear this data!", 'Are you sure?', 'warning', 'Confirm')
            .then((result) => {
                if (result.isConfirmed) {
                    clearState();
                }
            });
    };
    useEffect(() => {
    }, [selectedBranches]);
    useEffect(() => {
        bindFormPreloadData();
        bindFormData();
        // document.querySelectorAll(".navbar-nav .nav-item a")[2].classList.add("active");

        if (location.state.collegeid != null) {
            setIsUpdate(true);
        }
        else {
            setIsUpdate(false);
        }
        setTimeout(() => {
            // document.getElementById('nav-dropdownSuperadmin').parentElement.classList.add('show');
            // document.getElementById('nav-dropdownSuperadmin').nextSibling.classList.add('show');
            // document.getElementById('nav-dropdownSuperadmin').nextSibling.children[1].classList.add('active');
        }, 300);
    }, [])

    return (
        <div className='page'>
            {loading ? <GrokLoading /> : ""}
            {/* <NavMenu />
            <Header /> */}

            <div className='page-wrapper'>
                <Container fluid>
                    {/* Start Page Header */}
                    <div className='page-header d-print-none'>
                        <Row className='g-2 align-items-center'>
                            <div>
                                {/* <Breadcrumb className="custom-breadcrumb">
                                    <Breadcrumb.Item onClick={() => addRefresh()}> Home</Breadcrumb.Item>
                                    <Breadcrumb.Item onClick={() => handleCollege()}> Associate College</Breadcrumb.Item>
                                    <Breadcrumb.Item active>Associate College Detail</Breadcrumb.Item>
                                </Breadcrumb> */}
                            </div>
                            <Col>
                                <h2 className="page-title">Join as an Academic Partner</h2>
                                {!isUpdate && <h2 className="page-title">Add Associate College</h2>}
                                {isUpdate && <h2 className="page-title">Edit Associate College</h2>}
                            </Col>
                            <Col lg={2} className="mb-1" >
                                <Form.Group >
                                    <button className='newBtn_style' onClick={() => BackBtn()}>
                                        <span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M249.38 336L170 256l79.38-80m-68.35 80H342"></path><path fill="none" strokeMiterlimit="10" strokeWidth="32" d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"></path></svg></span>
                                        &nbsp;&nbsp;Back
                                    </button>
                                </Form.Group>
                            </Col>
                        </Row>
                    </div>
                    {/* End Page Header */}

                    <div className='py-3'>
                        <Row className='g-2 justify-content-center'>

                            <Col className='col-lg-10 mb-4'>
                                <Card className='card-hover-shadow'>
                                    <Card.Body>
                                        {/* <Card.Title className='fw-bold mb-3'>Add Student Information:</Card.Title> */}
                                        <Form autoComplete="off" noValidate validated={validated} onKeyDown={handleKeyDown} onSubmit={handleSubmit}>
                                            <div className='card-tabsmain'>
                                                <div className='card-details-boxs'>
                                                    <Row>
                                                        <Col lg={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label> <h4>Associate College Information</h4></Form.Label>
                                                            </Form.Group>
                                                        </Col><hr />
                                                        <Col lg={4}>
                                                            <Form.Label>College Type <em className="Required">*</em></Form.Label>
                                                            <Form.Select as="select" value={grovatortype} onChange={(e) => setGrovatortype(e.target.value)} required >
                                                                <option value={""}>Select</option>
                                                                {grovatorcollegetype.map((item) => 
                                                            <option value={item._id} key={item._id}>{item.Name}</option>
                                                            )}
                                                            </Form.Select>
                                                            <Form.Control.Feedback type="invalid">College Type is required</Form.Control.Feedback>
                                                        </Col>
                                                        <Col lg={4}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>College Name <em className="Required">*</em></Form.Label>
                                                                <div className='col'>
                                                                    <Form.Control type="text" minLength={3} id="name" value={collegeName} onChange={(e) => setCollegeName(e.target.value)} placeholder="Enter  College Name" required />
                                                                    <Form.Control.Feedback type="invalid">College Name is required</Form.Control.Feedback>
                                                                </div>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col lg={4}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>College Email <em className="Required">*</em></Form.Label>
                                                                <div className='col'>
                                                                    <Form.Control name="email" type="email" minLength={3} id="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Enter  College email" required />
                                                                    <Form.Control.Feedback type="invalid">Contact Email is required</Form.Control.Feedback>
                                                                </div>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col lg={4}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Address</Form.Label>
                                                                <div className='col'>
                                                                    <Form.Control type="text" id="Address1" value={address} onChange={(e) => setAddress(e.target.value)} placeholder="Enter Address" />
                                                                    <Form.Control.Feedback type="invalid">Address is required</Form.Control.Feedback>
                                                                </div>
                                                            </Form.Group>
                                                        </Col>
                                                         <Col lg={2}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Country <em className="Required">*</em></Form.Label>
                                                                <div className='col'>
                                                                    <Form.Select required as="select" value={country} onChange={countryChanged}>
                                                                        <option value={''}>Select</option>
                                                                        {countryList.map(item => (
                                                                            <option key={item.Id} value={item._id}>{item.Name}</option>
                                                                        ))}
                                                                    </Form.Select>
                                                                    <Form.Control.Feedback type="invalid">Country is required </Form.Control.Feedback>
                                                                </div>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col lg={2}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>State <em className="Required">*</em></Form.Label>
                                                                <div className='col'>
                                                                    <Form.Select required as="select" value={state} onChange={stateChanged}>
                                                                        <option value={''}>Select</option>
                                                                        {stateList.map(item => (
                                                                            <option key={item.Id} value={item._id}>{item.Name}</option>
                                                                        ))}
                                                                    </Form.Select>
                                                                    <Form.Control.Feedback type="invalid">State is required </Form.Control.Feedback>
                                                                </div>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col lg={2}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>District <em className="Required">*</em></Form.Label>
                                                                <div className='col'>
                                                                    <Form.Select required as="select" value={district} onChange={districtChanged}>
                                                                        <option value={''}>Select</option>
                                                                        {districtList.map(item => (
                                                                            <option key={item.Id} value={item._id}>{item.Name}</option>
                                                                        ))}
                                                                    </Form.Select>
                                                                    <Form.Control.Feedback type="invalid">District is required</Form.Control.Feedback>
                                                                </div>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col lg={2}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>City <em className="Required">*</em></Form.Label>
                                                                <div className='col'>
                                                                    <Form.Select required as="select" value={city} onChange={cityChanged} ><option value={""}>Select</option>
                                                                        {cityListData.map((item) => (
                                                                            <option key={item.Id} value={item._id}>{item.Name}</option>
                                                                        ))}
                                                                    </Form.Select>
                                                                    <Form.Control.Feedback type="invalid">City is required</Form.Control.Feedback>
                                                                </div>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col lg={4}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Pincode</Form.Label>
                                                                <div className='col'>
                                                                    <Form.Control type="numeric" id="Pincode" minLength={6} maxLength={6} value={pincode} onChange={(e) => setPincode(e.target.value)} placeholder="Enter Pincode" />
                                                                    {/* <Form.Control.Feedback type="invalid">Pincode is required</Form.Control.Feedback> */}
                                                                </div>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col lg={4}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label> Contact Person Name <em className="Required">*</em></Form.Label>
                                                                <div className='col'>
                                                                    <Form.Control name="name" type="text" minLength={3} id="name" value={contactName} onChange={(e) => setContactName(e.target.value)} placeholder="Enter Contact Name" required />
                                                                    <Form.Control.Feedback type="invalid">Contact Person Name is required</Form.Control.Feedback>
                                                                </div>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col lg={4}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label> Contact Person Email <em className="Required">*</em></Form.Label>
                                                                <div className='col'>
                                                                    <Form.Control name="email" type="email" minLength={3} id="email" value={contactEmail} onChange={(e) => setContactEmail(e.target.value)} placeholder="Enter Contact email" required />
                                                                    <Form.Control.Feedback type="invalid">Contact Person Email is required</Form.Control.Feedback>
                                                                </div>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col lg={4}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Contact Person Number</Form.Label>
                                                                <div className='col'>
                                                                    <Form.Control type=" numeric" minLength={5} maxLength={15} id="ContactNumber" value={contactNumber} placeholder="Enter Contact Number" onChange={(e) => setValuePhoneNumber(e.target.value)} />
                                                                    {/* {numberError && <div style={{ color: 'red' }}>{numberError}</div>} */}
                                                                    {/* <Form.Control.Feedback type="invalid">Contact Person Number is required</Form.Control.Feedback> */}
                                                                </div>
                                                            </Form.Group>
                                                        </Col>
                                                        <Col lg={4}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Branch <em className="Required">*</em></Form.Label>
                                                                <div className="col multiBranch">
                                                                    <Multiselect
                                                                        style={{
                                                                            multiselectContainer: {
                                                                                color: 'black',
                                                                            },
                                                                            searchBox: {
                                                                                outline:  validated && selectedBranches.length === 0 ? '1px solid red' : 'none',
                                                                            }
                                                                        }}
                                                                        options={branchlist.map(item => ({ label: item.Name, value: item._id }))}
                                                                        selectedValues={selectedBranches}
                                                                        onSelect={selectedList => { setSelectedBranches(selectedList) }}
                                                                        onRemove={selectedList => { setSelectedBranches(selectedList) }}
                                                                        displayValue="label"
                                                                        placeholder="Select branches"
                                                                    />
                                                                </div>
                                                                <Form.Control.Feedback type="invalid" style={{ display: validated && selectedBranches.length === 0 ? 'block' : 'none' }}>
                                                                    Branch is required
                                                                </Form.Control.Feedback>
                                                            </Form.Group>
                                                        </Col>
                                                        <Row className='mt-3'>
                                                            <Col lg={4}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Logo URL <span style={{ color: '#058798', marginLeft: '0.9rem', fontSize: '0.80em' }}>( Only 5MB files allowed )</span></Form.Label>
                                                                    <div className="col">
                                                                        <Form.Control id='logo' className="mb-2" ref={fileInputRef} accept=".jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff|image/*" type="file" onChange={convertToBase64} />
                                                                        <div className="d-flex justify-content-between align-items-center">{errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
                                                                            {showRemoveButton && <Button variant='warning' type="button" size="sm" className="ml-auto" onClick={handleRemoveLogo}>Remove</Button>}
                                                                        </div>
                                                                    </div>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <Form.Group className="mb-3">
                                                                    <Card style={{ width: '12rem' }}>
                                                                        <Card.Body>
                                                                            {
                                                                                logoURL &&
                                                                                <Card.Img variant="top" alt='uploaded file' src={logoURL} />
                                                                            }
                                                                        </Card.Body>
                                                                        {
                                                                            !logoURL &&
                                                                            <Card.Footer>
                                                                                <div className='outerbar'>
                                                                                    <div className='innerbar' style={{ width: `${progresspercent}%` }}>{progresspercent}%</div>
                                                                                </div>
                                                                            </Card.Footer>
                                                                        }
                                                                    </Card>
                                                                </Form.Group>
                                                            </Col>
                                                        </Row>
                                                        {/* <Col lg={4}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Branch<em className="Required">*</em></Form.Label>
                                                                <div className="col">
                                                                    <Form.Select as="select" value={branch} onChange={(e) => setBranch(e.target.value)} required >
                                                                        <option value={""}>Select</option>
                                                                        {branchlist.map(item => (
                                                                            <option key={item._id} value={item._id}>{item.Name}</option>
                                                                        ))}
                                                                    </Form.Select>
                                                                </div>
                                                            </Form.Group>
                                                        </Col> */}
                                                        {isUpdate && <Col lg={4}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Enable<em className="Required">*</em></Form.Label>
                                                                <div className='col'>
                                                                    <Form.Check type="switch" id="ChallengeStatus" checked={isEnabled} onChange={(e) => setIsEnabled(e.target.checked)} />
                                                                    <div className='col'>
                                                                    </div>
                                                                </div>
                                                            </Form.Group>
                                                        </Col>}
                                                        <Col lg={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Associate college Brief</Form.Label>
                                                                <div className='col'>
                                                                    <Form.Control as="textarea" aria-label="With textarea" style={{ height: '250px' }} value={collegeBrief} onChange={(e) => setCollegeBrief(e.target.value)} placeholder='Enter Associate college brief here...'/>
                                                                    {/* <Form.Control.Feedback type="invalid">Associate College Brief is required</Form.Control.Feedback> */}
                                                                </div>
                                                            </Form.Group>
                                                        </Col>
                                                        {/* <Col lg={4}>
                                                            <Form.Group className="mb-3"  >
                                                                <Form.Label> Contact Designation <em className="Required">*</em></Form.Label>
                                                                <div className='col'>
                                                                    <Form.Control name="name" type="text" minLength={3}  id="name" value={contactDesignation} onChange={(e) => setContactDesignation(e.target.value)} placeholder="Enter Contact Designation" required />
                                                                    <Form.Control.Feedback type="invalid">Contact Designation is required</Form.Control.Feedback>
                                                                </div>
                                                            </Form.Group>
                                                        </Col> */}
                                                        <Row>
                                                            <Col xs={4}>
                                                                <Button variant="danger" type="button" size="sm" aria-label="small button" color='error' onClick={() => clear()}>Clear</Button>
                                                            </Col>
                                                            <Col>
                                                                <div className="d-flex gap justify-content-end">
                                                                    <Button variant="success" color='success' size='sm' type="submit">Save</Button>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </Row>
                                                </div>
                                            </div>
                                        </Form>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </div>

                </Container>

                <Footer />
            </div>
        </div>

    );
}

export default EnrollAcademicInst;

